import { useAccounts } from '../store/accounts'
import type { Account } from '../store/accounts'

let _idx = 0

function liveAccounts(): Account[] {
  return useAccounts.getState().accounts.filter((a) => !a.deactivated)
}

/** Round-robin account selection for hydration batches.
 *  Each call advances the cursor so consecutive batches use different accounts. */
export function nextAccount(): Account | null {
  const live = liveAccounts()
  if (live.length === 0) return null
  const acc = live[_idx % live.length]
  _idx++
  return acc
}

/** Pick the account responsible for a given hours-ago bucket.
 *  Hour N always maps to the same account (circular), so all calls within
 *  one hour go through the same token while adjacent hours rotate. */
export function accountForHour(hoursAgo: number): Account | null {
  const live = liveAccounts()
  if (live.length === 0) return null
  return live[Math.floor(Math.abs(hoursAgo)) % live.length]
}
